import React from 'react';

function TripcoinIcon({ className, h, w, style, childrenClassNames }) {
  return (
    <svg
      className={className}
      width={w}
      height={h}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <g fill="none">
        <path
          className={childrenClassNames?.circle}
          fill="#212121"
          d="M0 6c0-3.31371189 2.68629222-6 6-6 3.31370414 0 6 2.68628811 6 6 0 3.31370004-2.68629586 6-6 6-3.31370778 0-6-2.68629996-6-6Z"
        />
        <path
          className={childrenClassNames?.text}
          fill="#ffffff"
          d="M8.025 3.61180179c.37279221 0 .675.31449424.675.70244255 0 .36023771-.26057713.65714003-.59628074.6977167L8.025 5.01668688l-1.351-.00088509.001 3.29355745c0 .38794831-.30220779.70244255-.675.70244255-.34616419 0-.63146733-.27117105-.67045878-.62052291L5.325 8.30935924V5.01580179l-1.35.00088509c-.37279221 0-.675-.31449424-.675-.70244254 0-.36023772.26057713-.65714004.59628074-.6977167L3.975 3.61180179h4.05Z"
        />
      </g>
    </svg>
  );
}

TripcoinIcon.defaultProps = {
  w: 12,
  h: 12,
  childrenClassNames: {},
};

export default TripcoinIcon;
